// @ts-nocheck
import * as React from "react";

const Facebook: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
            <g fill="currentColor" clipPath="url(#a)">
                <path d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Zm9.741 24.741A13.69 13.69 0 0 1 15 28.777a13.68 13.68 0 0 1-9.742-4.036A13.69 13.69 0 0 1 1.223 15c0-3.68 1.432-7.14 4.035-9.742A13.69 13.69 0 0 1 15 1.223c3.68 0 7.14 1.432 9.741 4.035A13.69 13.69 0 0 1 28.777 15c0 3.68-1.432 7.14-4.036 9.741Z" />
                <path d="M11.43 11.588h7.142l-.384 2.67H11.43v-2.67Zm1.255-.978c0-2.708.99-3.903 3.72-3.903h2.165V9.49h-2.09a.566.566 0 0 0-.5.252c-.114.167-.17.384-.17.65V23.29h-3.125V10.61Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h30v30H0z" />
                </clipPath>
            </defs>
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Facebook);
